/* eslint-disable react/forbid-prop-types,jsx-a11y/control-has-associated-label,import/prefer-default-export */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Dropdown } from '../../../../components/LargeList';

export const CustomDropdown = ({
  placeholder = null,
  name,
  onChange,
  dropDownParentClass = 'w-100',
  readOnly = false,
  value,
  options,
  isOpened,
  setIsOpened,
}) => {
  const { t: translate } = useTranslation();
  const [displayPlaceholder, setDisplayPlaceholder] = useState(false);
  const OPTION_HEIGHT = 44;
  const ROWS = 4;

  const toggleFormGroupHeight = (e) => {
    setIsOpened((prev) => !prev);
    if (!e.target) {
      e.target = document.getElementsByClassName('select_menu-container')[0];
    }
    const parentFormControl = e.target.closest('.form_group-container');
    const parentModal = e.target.closest('.modal-content');
    if (parentModal) {
      if (!isOpened) {
        parentModal.style.minHeight = '51.5rem';
        parentModal.style.height = 'auto';
      } else {
        parentModal.style.minHeight = '';
        parentModal.style.height = '51.5rem';
      }
    }
    if (!isOpened && parentFormControl) {
      parentFormControl.style.height = `${parentFormControl.offsetHeight + OPTION_HEIGHT * ROWS}px`;
    } else if (parentFormControl) {
      parentFormControl.style.height = 'auto';
    }
  };

  const handleClick = (val, fieldName) => {
    setIsOpened(false);
    onChange(val, fieldName);
  };

  return (
    <Dropdown
      isOpen={isOpened}
      onClose={toggleFormGroupHeight}
      dropDownParentClass={dropDownParentClass}
      target={
        <>
          <input
            autoComplete="off"
            type="text"
            className="bg-transparent w-100 my-0 form-control-input pe-1"
            placeholder={placeholder}
            value={value.description}
            required
            name={name}
            onFocus={() => setDisplayPlaceholder(true)}
            onBlur={() => {
              setDisplayPlaceholder(false);
            }}
            onClick={(e) => {
              if (!readOnly) {
                toggleFormGroupHeight(e);
              }
            }}
            readOnly
          />
          {displayPlaceholder && <label className="floating-label">{placeholder}</label>}
          {!readOnly && (
            <i
              tabIndex={0}
              className={`${
                isOpened ? 'text-primary' : 'text-shadow'
              } position-absolute top-50 end-0 translate-middle-y`}
              role="button"
              onClick={(e) => {
                if (!readOnly) {
                  toggleFormGroupHeight(e);
                }
              }}
              onKeyDown={() => {}}>
              <ChevronDown
                style={{
                  transform: `rotate(${isOpened ? '180deg' : '0deg'})`,
                }}
              />
            </i>
          )}
          <label className="floating-label">{placeholder}</label>
          <label className="error-label">{translate('input_required_error_label')}</label>
        </>
      }>
      <ul
        style={{ zIndex: 101, maxHeight: '12rem' }}
        className="position-absolute ps-5 bg-light shadow-lg purpose-of-account list-group purpose-of-account-list overflow-auto w-100">
        {options &&
          options.map((item) => (
            <li key={item.id} className="list-group-item purpose-of-account-list-item bg-light">
              <div
                role="button"
                tabIndex="0"
                onClick={() =>
                  handleClick(
                    { key: item.key, description: item.description },
                    camelCase(item.risk_type_key) // e.g. purpose_of_account => purposeOfAccount
                  )
                }
                onKeyDown={() => {}}>
                {item.description}
              </div>
            </li>
          ))}
      </ul>
    </Dropdown>
  );
};

CustomDropdown.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
  setIsOpened: PropTypes.func.isRequired,
  dropDownParentClass: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.shape({
    key: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  options: PropTypes.array.isRequired,
};
